export enum ENVIRONMENT {
    local,
    development,
    homologation,
    production
}